export default __webpack_public_path__ + "static/media/backgroundImg1.534e0e3b.svg";